import Abstract from './Abstract.js';

export default class Axis extends Abstract {
  constructor(props) {
    super(props);
  }
}
